import React from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({

    title: {
        textAlign: 'center',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(3),
        },
    },
    actions: {
        justifyContent: 'center',
        marginTop: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
        },
    },
    content: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        }
    }

}));

export const FingotiModalContent = (props) => <DialogContent dividers {...props} />

export const FingotiModalActions = (props) => {

    const classes = useStyles();

    return <DialogActions className={classes.actions} {...props} />
}

export const FingotiModal = ({ open, setOpen, title, children }) => {

    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="paper"
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            style={{ zIndex: 1320 }}
        >
            <DialogTitle
                className={classes.title}
                disableTypography
            >
                <Typography variant="h4">{title}</Typography>
            </DialogTitle>
            {children}
            {/* <div
                style={{
                    top: `${top}%`,
                    left: `${left}%`,
                    transform: `translate(-${top}%, calc(-${left}% + 180px))`,
                }}
                className={classes.paper}
            >
                <Typography className={classes.title} variant="h4">
                    {title}
                </Typography>
                <div className={classes.content}>
                    {children}
                </div>
            </div> */}
        </Dialog>
    );
}